import { useAppSelector } from ".";

import { Workspace } from "../api";
import { useRequiredParams } from "./use-required-params";

export const useWorkspace = (): Workspace | undefined => {
  const { workspace } = useRequiredParams(["workspace"]);
  const { workspaces } = useAppSelector((s) => s.workspace);
  return workspaces.find((w) => w.slug === workspace);
};
